module.exports = __webpack_public_path__ + "img/BigData2.e0987518.png";